<template>
  <main class="new-main">
    <div class="left-col">
      <TextBanner
        v-if="banners.length > 0"
        @open-medical-trend="openMedicalTrendPopup"
        @open-drug-info="openDrugInfoPopup"
        @open-survey="openSurveyPopup"
        @open-webseminar="linkToSeminar"
        @open-notice="linkToNotice"
        @open-event="linkToEvent"
        @open-drug-landing="openDrugLanding"
      />
      <Content
        v-if="isLiveOptionActivity || isSurveyActivity"
        @open-drug-info="openDrugInfoPopup"
        @open-survey="openSurveyPopup"
      />
      <LeftBanner
        v-if="banners.length > 0"
        @open-medical-trend="openMedicalTrendPopup"
        @open-drug-info="openDrugInfoPopup"
        @open-survey="openSurveyPopup"
        @open-webseminar="linkToSeminar"
        @open-notice="linkToNotice"
        @open-event="linkToEvent"
      />
      <Kma
        @open-kma="openKma"
        @link-with-stat="linkWithStat"
      />
    </div>
    <div class="right-col">
      <Account
        @link-with-stat="linkWithStat"
      />
      <!-- 임시 버전 표시 제거 -->
      <div class="easy-register-wrap">
        <h2>
          실행 앱 버전 : {{ appVersion }}
        </h2>
        <h2>
          연결된 서버 : 2번 서버 (3.0.1.7 이하 버전 연결)
        </h2>
      </div>
      <!-- 임시 버전 표시 제거 End -->
      <LiveLanding
        v-if="isDrugLandingActivity"
        @open-drug-landing="openDrugLanding"
      />
      <RightBanner
        v-if="banners.length > 0"
        @open-medical-trend="openMedicalTrendPopup"
        @open-drug-info="openDrugInfoPopup"
        @open-survey="openSurveyPopup"
        @open-webseminar="linkToSeminar"
        @open-notice="linkToNotice"
        @open-event="linkToEvent"
      />
      <div class="custom-content-area">
        <button class="btn-custom-content">
          맞춤형 컨텐츠<i />
        </button>
        <div class="more-tooltip">
          <HoverInfoTip />
        </div>
      </div>
    </div>
    <!-- 팝업 -->
    <popup-drug-info-view
      v-if="mountedDrugInfoPopup"
      ref="popupDrugInfoView"
      @statUpdate="statUpdateDrugInfo"
    />
    <popup-medical-view
      v-if="mountedMedicalPopup"
      ref="popupMedicalView"
      @statUpdate="statUpdateMedicalTrend"
    />
    <popup-survey-view
      v-if="mountedSurveyPopup"
      :id="surveyId"
      :entry-service-type="surveyEntryService"
      :entry-position-type="surveyEntryPosition"
      :entry-state-type="surveyEntryState"
      :show-modal="showSurvey"
      @close="closeSurveyView"
    />
    <alert-dialog :options="alertProps" />
  </main>
</template>

<script>
import dayjs from 'dayjs'
import axios from '@axios'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// import sampleMedicalImg from '@/assets/images/banner/img-mainbanner.jpg'
// import sampleDrugInfoImg from '@/assets/images/banner/img-infobanner.jpg'
import { mapGetters, mapMutations } from 'vuex'
import { callExternalApi } from '@/core/global/global-liveinfo'
import { setStatisticsNew } from '@/common/statistics/service'
import { errorFormatter } from '@/libs/utils/filters'
import { isUserLoggedIn } from '@/auth/utils'
// import PopupMain from '@/views/apps/popup/PopupMain.vue'
import PopupDrugInfoView from './popup/PopupDrugInfoView.vue'
import PopupMedicalView from './popup/PopupMedicalView.vue'
import PopupSurveyView from './popup/PopupSurveyView.vue'

import Account from './components/Account.vue'
import Content from './components/Content.vue'
import Kma from './components/Kma.vue'
import LiveLanding from './components/LiveLanding.vue'
import TextBanner from './components/TextBanner.vue'
import LeftBanner from './components/LeftBanner.vue'
import RightBanner from './components/RightBanner.vue'
import HoverInfoTip from './util/HoverInfoTip.vue'

export default {
  components: {
    Swiper,
    SwiperSlide,
    // PopupMain,
    PopupDrugInfoView,
    PopupMedicalView,
    PopupSurveyView,
    Account,
    Content,
    Kma,
    LiveLanding,
    TextBanner,
    LeftBanner,
    RightBanner,
    HoverInfoTip,
  },
  data() {
    return {
      // medicals: [
      //   { id: 1, filePath: null },
      //   { id: 2, filePath: null },
      //   { id: 3, filePath: null },
      //   { id: 4, filePath: null },
      // ],
      // medicalSwiperOptions: {
      //   slidesPerView: 1,
      //   centeredSlides: false,
      //   slideToClickedSlide: false,
      //   // grabCursor: false,
      //   initialSlide: 0,
      //   paginationClickable: false,
      //   scrollbar: ".swiper-scrollbar",
      //   touchRatio: 0,
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true,
      //   },
      // },
      // drugInfos: [
      //   { id: 1, filePath: null },
      //   { id: 2, filePath: null },
      //   { id: 3, filePath: null },
      //   { id: 4, filePath: null },
      // ],
      // drugInfoSwiperOptions: {
      //   slidesPerView: 1,
      //   centeredSlides: false,
      //   slideToClickedSlide: false,
      //   // grabCursor: false,
      //   initialSlide: 0,
      //   paginationClickable: false,
      //   scrollbar: ".swiper-scrollbar",
      //   touchRatio: 0,
      //   loop: true,
      //   autoplay: {
      //     delay: 5000,
      //     disableOnInteraction: false,
      //   },
      //   navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev',
      //   },
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true,
      //     type: "fraction",
      //   },
      // },
      // surveyCount: 0,
      // survey: {
      //   id: 0,
      //   surveyType: null,
      //   title: null,
      //   summary: null,
      //   startDate: null,
      //   endDate: null,
      //   rewardPoint: 0,
      // },
      // seminarCount: 0,
      // seminar: null,
      // popups: [],
      // 임시 버전 표시 제거
      appVersion: null,
      // 임시 버전 표시 제거 End
      mountedDrugInfoPopup: false,
      mountedMedicalPopup: false,
      mountedSurveyPopup: false,
      surveyId: null,
      showSurvey: false,
      surveyEntryService: null,
      surveyEntryPosition: null,
      surveyEntryState: null,
    }
  },
  computed: {
    ...mapGetters({
      medicalDept: 'infoData/getMedicalDept',
      region: 'infoData/getRegion',
      shaYoyangNum: 'infoData/getShaYoyangNum',
      shaEnLicenseNum: 'infoData/getShaEnLicenseNum',
      isMonitoringFirstClick: 'infoData/getIsMonitoringFirstClick',
      isLiveOptionActivity: 'infoData/getIsLiveOptionActivity',
      isSurveyActivity: 'infoData/getIsSurveyActivity',
      isLiveDiActivity: 'infoData/getIsLiveDiActivity',
      isDrugLandingActivity: 'infoData/getIsDrugLandingActivity',
      banners: 'infoData/getBanners',
      drugInfos: 'infoData/getDrugInfos',
      surveys: 'infoData/getSurveys',
      join: 'util/getJoin', // 회원여부
    }),
  },
  watch: {
    // shaEnLicenseNum() {
    //   this.getSurvey()
    //   this.getNoticePopup()
    //   this.getMedicalTrend()
    //   this.getWebSeminar()
    //   this.getDrugInfo()
    // },
  },
  mounted() {
    // 임시 버전 표시 제거
    this.fetchAppVersion()
    // 임시 버전 표시 제거 End
    // if (this.shaEnLicenseNum) {
    //   this.getSurvey()
    //   this.getNoticePopup()
    //   this.getMedicalTrend()
    //   this.getWebSeminar()
    //   this.getDrugInfo()
    // }
  },
  methods: {
    // 임시 버전 표시 제거
    async fetchAppVersion() {
      try {
        if (window.CefSharp) {
          await window.CefSharp.BindObjectAsync('appConfig')
          this.appVersion = await window.appConfig.getVersion()
        }
      } catch (e) {
        this.appVersion = ''
      }
    },
    // 임시 버전 표시 제거 End
    ...mapMutations({
      setIsMonitoringFirstClick: 'infoData/setIsMonitoringFirstClick',
    }),
    // 자동실행 첫 클릭 체크: 모니터링 중이면 클릭(210xxx) → 자동유입(220xxx) 변환 후 소비
    checkFirstClick(stateType) {
      if (this.isMonitoringFirstClick && stateType >= 210000 && stateType < 220000) {
        this.setIsMonitoringFirstClick(false)
        return stateType + 10000
      }
      return stateType
    },
    // linkToSurvey(id, surveyType) {
    //   this.$router.push({ name: 'app-survey-main', params: { id, surveyType, entry: 156 } }) // 확인 후 변경or제거
    // },
    // getMedicalTrend() {
    //   axios.post("/fu/dashboard/medicals", {
    //     medicalDept: this.medicalDept,
    //     region: this.region,
    //     shaEnLicenseNum: this.shaEnLicenseNum,
    //   })
    //     .then(rs => {
    //       this.medicals = rs.data
    //     })
    //     .catch(error => {
    //       this.showAlertDialog(error.response.data)
    //     })
    // },
    // getDrugInfo() {
    //   axios.post("/fu/dashboard/druginfos", {
    //     medicalDept: this.medicalDept,
    //     region: this.region,
    //     shaEnLicenseNum: this.shaEnLicenseNum,
    //   })
    //     .then(rs => {
    //       this.drugInfos = rs.data
    //     })
    //     .catch(error => {
    //       this.showAlertDialog(error.response.data)
    //     })
    // },
    // getWebSeminar() {
    //   axios.post("/fu/dashboard/seminars", {
    //     medicalDept: this.medicalDept,
    //     region: this.region,
    //     shaEnLicenseNum: this.shaEnLicenseNum,
    //   })
    //     .then(rs => {
    //       this.seminarCount = rs.data.seminarCount
    //       this.seminar = rs.data.seminar
    //     })
    //     .catch(error => {
    //       this.showAlertDialog(error.response.data)
    //     })
    // },
    // getSurvey() {
    //   axios.post('/fu/dashboard/surveys', {
    //     medicalDept: this.medicalDept,
    //     region: this.region,
    //     shaYoyangNum: this.shaYoyangNum,
    //     shaEnLicenseNum: this.shaEnLicenseNum,
    //   })
    //     .then(rs => {
    //       this.surveyCount = rs.data.joinAbleCount
    //       this.survey = rs.data.survey

    //       if (rs.data.inCompleteSurvey) {
    //         const liveInfoId = rs.data.inCompleteSurvey
    //         const surveyStatus = rs.data.inCompleteSurveyStatus

    //         let message = ''
    //         if (surveyStatus === 1) message = '완료하지 않은 설문이 있습니다.\n계속 참여하시겠습니까?'
    //         else return

    //         this.showConfirmDialog(message, confirm => {
    //           if (confirm) {
    //             this.linkToSurvey(liveInfoId, 1)
    //           } else {
    //             axios.patch(`/fu/survey/skip-continue/${liveInfoId}`, this.shaEnLicenseNum)
    //           }
    //         })
    //       }
    //     })
    //     .catch(error => {
    //       this.showAlertDialog(error.response.data)
    //     })
    // },
    // getNoticePopup() {
    //   axios.post('/fu/dashboard/notice-popups', {
    //     shaEnLicenseNum: this.shaEnLicenseNum,
    //   })
    //     .then(rs => {
    //       this.popups = rs.data
    //     })
    //     .catch(error => {
    //       this.showAlertDialog(error.response.data)
    //     })
    // },
    // dontShowNoticePopup(id, againDay) {
    //   axios.patch(`/fu/dashboard/notice-popup/${id}`, {
    //     shaEnLicenseNum: this.shaEnLicenseNum,
    //     popupAgainDays: againDay,
    //   })
    //     .then(() => {
    //     })
    //     .catch(() => {
    //       this.showAlertDialog("팝업 다시 보지 않기 설정 과정에서 오류가 발생하였습니다.")
    //     })
    // },
    // clickSwiper(event) {
    //   if (!event.target.classList.contains('swiper-button-next') && !event.target.classList.contains('swiper-button-prev')) {
    //     const item = this.drugInfos[this.$refs.swiper.$swiper.realIndex]

    //     if (item.externalLink !== null && item.externalLink.length > 0) {
    //       setStatistics(136, item.id) // 엑셀 파일과 매칭되는 통계 값이 없음.

    //       callExternalApi("LinkUrl", item.externalLink)
    //     } else this.$router.push({ name: 'app-druginfo-main', query: { id: item.id, entry: 136 } })
    //   }
    // },
    // linkPopupPage(obj) {
    //   // noticeType 1: 공지사항 / 2: 이벤트
    //   if (obj.noticeType === 1) this.$router.push({ name: 'app-notice-main', query: { id: obj.id, entry: 210 } })
    //   else if (obj.noticeType === 2) this.$router.push({ name: 'app-event-main', query: { id: obj.id, entry: 124 } })
    // },
    // closePopup(obj) {
    //   const targetIdx = this.popups.findIndex(x => x.id === obj.id)
    //   // 화면에서 팝업 제거(닫기)
    //   this.popups.splice(targetIdx, 1)

    //   if (obj.againDay !== -1) this.dontShowNoticePopup(obj.id, obj.againDay)
    // },

    async checkedLogin() {
      const isLoggedIn = await isUserLoggedIn()

      if (!isLoggedIn && this.join) {
        this.$router.push({
          name: 'login-main',
          query: { redirect: this.$route.name },
        })

        return false
      }
      return true
    },
    // 약품정보 팝업
    openDrugInfoPopup(contentId, serviceType, positionType, stateType) {
      this.mountedDrugInfoPopup = true
      this.$nextTick(() => {
        this.$refs.popupDrugInfoView.openDrugInfoModal(contentId)
        this.statUpdateDrugInfo(contentId, serviceType, positionType, this.checkFirstClick(stateType))
      })
    },
    statUpdateDrugInfo(id, serviceType, positionType, stateType) {
      setStatisticsNew(serviceType, positionType, stateType, id)
    },
    // 메디컬 트렌드 팝업
    openMedicalTrendPopup(contentId, serviceType, positionType, stateType) {
      this.mountedMedicalPopup = true
      this.$nextTick(() => {
        this.$refs.popupMedicalView.openMedicalModal(contentId)
        this.statUpdateMedicalTrend(contentId, serviceType, positionType, this.checkFirstClick(stateType))
      })
    },
    statUpdateMedicalTrend(id, serviceType, positionType, stateType) {
      setStatisticsNew(serviceType, positionType, stateType, id)
    },
    // 설문조사 팝업
    async openSurveyPopup(contentId, serviceType, positionType, stateType) {
      const checkLogin = await this.checkedLogin()
      if (checkLogin === false) return

      const item = await this.fetchSurveyById(contentId)
      if (item) {
        const now = dayjs().format('YYYY-MM-DD')
        if (!item.isRewardNotChoice || now > dayjs(item.endDate).format('YYYY-MM-DD')) { // #202893 2025.12.03 보상받지못한 사용자 아래 체크 패스
          if (item.isFinish) {
            this.showAlertDialog('종료된 설문입니다.')
            return
          }
          if (item.isNonTarget) {
            this.showAlertDialog('설문조사 참여 대상에 해당되지 않아 참여가 불가합니다.')
            return
          }
          if (item.isAnswered) {
            this.showAlertDialog('해당 설문에 이미 참여하셨습니다.')
            return
          }
          if (item.isAnsweredDupJoin) {
            this.showAlertDialog('해당 설문에 이미 참여하셨습니다.\n(*기관 대상 설문으로 소속 의원 설문 참여완료로 확인)')
            return
          }
        }

        // (260420) {요청:김연수M}: 정책 확인 결과 아래 2가지 사항 감안하여 운영함.
        //  1) 설문 참여조건 미통과(로그인 실패, 종료, 참여완료 등) 시에는 클릭 stat 쌓지 않으며 클릭로그 유실될 수 있음 인지함.
        //  2) 현재 checkFirstClick은 stat 시점에서 소비하므로, await 중 다른 클릭이 먼저 소비하면 순서가 역전될 수 있음
        //     → ex. 설문조사 클릭 후 약품정보 클릭 시 검증 타이밍에 따라 약품정보가 자동유입으로 처리될 수 있음 인지함.
        const resolvedState = this.checkFirstClick(stateType)

        this.mountedSurveyPopup = true
        this.$nextTick(() => {
          this.surveyId = contentId
          this.surveyEntryService = serviceType
          this.surveyEntryPosition = positionType
          this.surveyEntryState = resolvedState
          this.showSurvey = true

          this.statUpdateSurvey(contentId, this.surveyEntryService, this.surveyEntryPosition, this.surveyEntryState)
        })
      }
    },
    statUpdateSurvey(id, serviceType, positionType, stateType) {
      setStatisticsNew(serviceType, positionType, stateType, id)
    },
    closeSurveyView() {
      this.surveyId = null
      this.showSurvey = false
      this.surveyEntryService = null
      this.surveyEntryPosition = null
      this.surveyEntryState = null
    },
    async fetchSurveyById(id) {
      try {
        const item = await axios.post(`/fu/survey/${id}`, {
          medicalDept: this.medicalDept,
          shaYoyangNum: this.shaYoyangNum,
          shaEnLicenseNum: this.shaEnLicenseNum,
        })
        return item.data
      } catch (err) {
        if (err.response && err.response.status === 404) {
          this.showAlertDialog('현재 진행할 수 없는 설문입니다.')
        } else {
          this.showAlertDialog(errorFormatter(err, '설문 데이터를 불러오는 과정에서 오류가 발생하였습니다.'))
        }
        return null
      }
    },
    // 웹세미나 링크 이동
    linkToSeminar(contentId, seminarType, serviceType, positionType, stateType) {
      const resolvedState = this.checkFirstClick(stateType)
      this.$router.push({
        name: 'app-webseminar-client',
        params: {
          id: contentId, seminarType, entryService: serviceType, entryPosition: positionType, entryState: resolvedState
        }
      })
    },
    // 공지사항 링크 이동
    linkToNotice(contentId, serviceType, positionType, stateType) {
      const resolvedState = this.checkFirstClick(stateType)
      this.$router.push({
        name: 'app-notice-main',
        query: {
          id: contentId, entryService: serviceType, entryPosition: positionType, entryState: resolvedState
        }
      })
    },
    // 이벤트도 링크 이동
    linkToEvent(contentId, serviceType, positionType, stateType) {
      const resolvedState = this.checkFirstClick(stateType)
      this.$router.push({
        name: 'app-event-main',
        query: {
          id: contentId, entryService: serviceType, entryPosition: positionType, entryState: resolvedState
        }
      })
    },
    // 간편처방등록 (App에서 이관 — 다음 배포에서 Position 분리 예정, 현재는 App과 동일 값 사용)
    openDrugLanding(contentId, serviceType, positionType, stateType) {
      setStatisticsNew(
        serviceType,
        positionType,
        this.checkFirstClick(stateType),
        contentId,
      )
      callExternalApi('CallLandingPopup', String(contentId))
    },
    // KMA 연수교육 세미나 링크
    openKma(item, serviceType, positionType, stateType) {
      setStatisticsNew(serviceType, positionType, this.checkFirstClick(stateType), item.kmaSeminarId)
      callExternalApi('LinkUrl', `https://edu.kma.org/edu/schedule_view?eduidx=${item.kmaSeminarId}`)
    },
    // 페이지 이동 (컨텐츠 X)
    linkWithStat(route, serviceType, positionType, stateType) {
      setStatisticsNew(serviceType, positionType, this.checkFirstClick(stateType), 0)
      this.$router.push({ name: route }).catch(() => {})
    },
  },
}
</script>
